import { render, staticRenderFns } from "./VisualizarTreinamentos.vue?vue&type=template&id=857f4c8a&"
import script from "./VisualizarTreinamentos.vue?vue&type=script&lang=js&"
export * from "./VisualizarTreinamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports